import { Calendar, AlertTriangle } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import { formatDate, getPriorityConfig } from '../../utils/helpers';
import Avatar from '../common/Avatar';
import Badge from '../common/Badge';

export default function UpcomingDeadlines() {
  const { state, getUserById, dispatch } = useApp();

  const upcoming = state.tasks
    .filter((t) => t.dueDate && t.status !== 'done')
    .sort((a, b) => (a.dueDate || '').localeCompare(b.dueDate || ''))
    .slice(0, 6);

  const isOverdue = (date: string) => new Date(date) < new Date();

  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-4 md:p-5">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-semibold text-slate-700">Próximos Prazos</h3>
        <Calendar size={16} className="text-slate-400" />
      </div>

      <div className="space-y-3">
        {upcoming.map((task) => {
          const priority = getPriorityConfig(task.priority);
          const assignee = task.assigneeIds[0] ? getUserById(task.assigneeIds[0]) : null;
          const overdue = task.dueDate ? isOverdue(task.dueDate) : false;

          return (
            <button
              key={task.id}
              onClick={() => dispatch({ type: 'SELECT_TASK', payload: task.id })}
              className="w-full flex items-center gap-3 p-3 rounded-xl hover:bg-slate-50 transition-colors text-left group"
            >
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-slate-700 truncate group-hover:text-brand-600 transition-colors">
                  {task.title}
                </p>
                <div className="flex items-center gap-2 mt-1">
                  <Badge className={priority.color} dot={priority.dot}>
                    {priority.label}
                  </Badge>
                  {task.dueDate && (
                    <span
                      className={`flex items-center gap-1 text-xs ${
                        overdue ? 'text-red-500 font-medium' : 'text-slate-400'
                      }`}
                    >
                      {overdue && <AlertTriangle size={10} />}
                      {formatDate(task.dueDate)}
                    </span>
                  )}
                </div>
              </div>
              {assignee && (
                <Avatar
                  name={assignee.name}
                  color={assignee.avatarColor}
                  size="sm"
                />
              )}
            </button>
          );
        })}

        {upcoming.length === 0 && (
          <p className="text-center text-sm text-slate-400 py-6">Nenhum prazo próximo</p>
        )}
      </div>
    </div>
  );
}
